(function () {
  'use strict';

  var UF_TO_PROVINCE = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
    MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná',
    PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia',
    RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe',
    TO: 'Tocantins',
  };

  function setProvince(uf) {
    var select = document.getElementById('AddressProvinceCalculator');
    var provinceName = UF_TO_PROVINCE[uf];
    if (!select || !provinceName) return;

    var matched = Array.prototype.some.call(select.options, function (opt) {
      if (opt.value === provinceName) {
        select.value = provinceName;
        return true;
      }
      return false;
    });
    if (!matched) {
      var normalize = function (s) {
        return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      };
      Array.prototype.some.call(select.options, function (opt) {
        if (normalize(opt.value) === normalize(provinceName)) {
          select.value = opt.value;
          return true;
        }
        return false;
      });
    }
  }

  function triggerCalculate(zipInput) {
    var calculator = zipInput.closest('shipping-calculator');
    var button = calculator && calculator.querySelector('button');
    if (button) button.click();
  }

  var cepTimeout = null;

  function lookupCep(zipInput) {
    var digits = zipInput.value.replace(/\D/g, '');
    if (digits.length !== 8) return;

    // pequeno atraso pra evitar disparos duplicados (ex: colar o CEP
    // gera vários eventos "input" em sequência)
    clearTimeout(cepTimeout);
    cepTimeout = setTimeout(function () {
      fetch('https://viacep.com.br/ws/' + digits + '/json/')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && !data.erro && data.uf) {
            setProvince(data.uf);
            triggerCalculate(zipInput);
          }
        })
        .catch(function (err) {
          console.error('custom-shipping-calculator:', err);
        });
    }, 300);
  }

  document.addEventListener('input', function (event) {
    if (event.target && event.target.id === 'AddressZipCalculator') {
      lookupCep(event.target);
    }
  });

  // Se o campo já vem preenchido ao carregar a página (CEP do endereço
  // cadastrado do cliente logado — ver snippets/shipping-calculator.liquid),
  // dispara a mesma busca automaticamente, sem esperar a pessoa digitar.
  document.addEventListener('DOMContentLoaded', function () {
    var zipInput = document.getElementById('AddressZipCalculator');
    if (zipInput && zipInput.value) {
      lookupCep(zipInput);
    }
  });
})();